"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = (0, _styledComponents.default)(_fiverReactUiComponents.Card)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));

var StyledLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0.5rem;\n  font-family: ", ";\n  text-align: center;\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (props) {
  return props.theme.colorLabel;
});

var StyledValue = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 37px;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorSuccess;
});

var WalletBalance = function WalletBalance(_ref) {
  var textLabel = _ref.textLabel,
      balance = _ref.balance,
      currencySymbol = _ref.currencySymbol;
  return /*#__PURE__*/_react.default.createElement(StyledCard, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledLabel, null, textLabel), /*#__PURE__*/_react.default.createElement(StyledValue, null, balance !== undefined ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currencySymbol, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.PenceToPounds, null, balance)) : /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Skeleton, {
    skeletonWidth: "105px",
    skeletonHeight: "20px",
    skeletonBorderRadius: "4px"
  }))));
};

var _default = WalletBalance;
exports.default = _default;